export enum KybFormFields {
  IdentityDocument = 'identityDocument',
  IdentityDocumentExpiryDate = 'identityDocumentExpiryDate',
  SupportingDocuments = 'supportingDocuments',
  Ubos = 'ubos',
}
